import { createContext } from 'react'
import { TListsContext } from './types'

export const ListsContext = createContext<TListsContext>({

})